/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { api_createJobRequest } from '../models/api_createJobRequest';
import type { api_createJobResponse } from '../models/api_createJobResponse';
import type { api_getJobResponse } from '../models/api_getJobResponse';
import type { api_getUnviewedJobsCountResponse } from '../models/api_getUnviewedJobsCountResponse';
import type { db_ListJobsRow } from '../models/db_ListJobsRow';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class Jobs {
    /**
     * Get a list of jobs for the current user
     * @param pageId Page ID
     * @param pageSize Page size
     * @param orderBy Order by
     * @param filters Filters
     * @param filterModes Filter modes
     * @param search Search string
     * @returns db_ListJobsRow OK
     * @throws ApiError
     */
    public static listJobs(
        pageId: number,
        pageSize: number,
        orderBy?: string,
        filters?: string,
        filterModes?: string,
        search?: string,
    ): CancelablePromise<Array<db_ListJobsRow>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobs',
            query: {
                'page_id': pageId,
                'page_size': pageSize,
                'order_by': orderBy,
                'filters': filters,
                'filter_modes': filterModes,
                'search': search,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Create an async job
     * @param body Job request
     * @returns api_createJobResponse OK
     * @throws ApiError
     */
    public static createJob(
        body: api_createJobRequest,
    ): CancelablePromise<api_createJobResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/jobs',
            body: body,
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get count of completed, unviewed jobs for the current user
     * @returns api_getUnviewedJobsCountResponse OK
     * @throws ApiError
     */
    public static getUnviewedJobsCount(): CancelablePromise<api_getUnviewedJobsCountResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobs/unviewed-count',
            errors: {
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Get job status
     * @param id Job ID
     * @returns api_getJobResponse OK
     * @throws ApiError
     */
    public static getJob(
        id: number,
    ): CancelablePromise<api_getJobResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/jobs/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                404: `Not Found`,
                500: `Internal Server Error`,
            },
        });
    }
    /**
     * Mark job as viewed
     * @param id Job ID
     * @returns void
     * @throws ApiError
     */
    public static markJobViewed(
        id: number,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'PATCH',
            url: '/jobs/{id}/viewed',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                500: `Internal Server Error`,
            },
        });
    }
}
